"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Modal = _interopRequireDefault(require("@material-ui/core/Modal"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var Modal = function Modal(_ref) {
  var children = _ref.children,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      _ref$opacity = _ref.opacity,
      opacity = _ref$opacity === void 0 ? 0.5 : _ref$opacity,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      _ref$disablePortal = _ref.disablePortal,
      disablePortal = _ref$disablePortal === void 0 ? false : _ref$disablePortal,
      id = _ref.id,
      _ref$onBackdropClick = _ref.onBackdropClick,
      onBackdropClick = _ref$onBackdropClick === void 0 ? function () {} : _ref$onBackdropClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default, {
    id: id,
    "aria-labelledby": "modal-title",
    "aria-describedby": "modal-description",
    open: open,
    onClose: onClose,
    className: _styleModule.default.modal,
    BackdropProps: {
      style: {
        backgroundColor: "rgba(0, 0, 0, ".concat(opacity, ")")
      }
    },
    disablePortal: disablePortal,
    onBackdropClick: onBackdropClick,
    children: children
  });
};

var _default = Modal;
exports.default = _default;